import { auth } from "utils/nhost";

const getDefaultBudget = () => {
  return auth.getClaim('x-hasura-default-budget-id');
};

export default getDefaultBudget;